var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAvatarEsophia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#337AEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9083 8.12939H7.18016C7.14681 8.12939 7.09461 8.18753 7.08984 8.21971V11.2905H20.9083C20.9416 11.2905 20.9986 11.3227 20.9986 11.2905V8.21971C20.9986 8.19349 20.9416 8.13535 20.9083 8.12939ZM20.9083 16.7095H7.08984V19.7802C7.08984 19.8124 7.14204 19.8705 7.18016 19.8705H20.9083C20.9416 19.8705 20.9986 19.8124 20.9986 19.7802V16.7095C20.9986 16.682 20.9416 16.7154 20.9083 16.7095Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9087 12.7355C20.9099 13.4951 20.9111 14.2327 20.9087 14.9935C20.9075 15.3567 20.0959 15.445 20.0959 15.445C17.9785 15.4462 18.4188 15.4486 16.3026 15.445C15.5677 15.4439 14.8498 15.5276 14.3156 16.0773C14.22 16.1752 14.1367 16.1704 14.0447 16.0773C13.5381 15.5689 12.935 15.4462 12.2384 15.445C11.2968 15.4439 10.8498 15.4498 10.0708 15.445C9.95366 15.4439 9.84691 15.4462 9.70949 15.445H9.61918C9.58572 15.445 9.55754 15.4427 9.52886 15.445H7.5419C7.26468 15.445 7 15.178 7 14.9031V13.8193V13.8193V12.284H9.52886C9.58383 12.291 9.61988 12.2863 9.70949 12.284C9.79314 12.2828 9.85976 12.284 9.98044 12.284H10.0708C11.004 12.2946 11.2148 12.3052 12.148 12.284C12.9092 12.2675 13.4896 12.5189 13.9544 13.0968C14.1133 13.295 14.2303 13.3138 14.406 13.0968C14.8851 12.5035 15.5187 12.2757 16.3026 12.284C18.3901 12.304 18.8213 12.2828 20.9087 12.284C20.9087 12.284 20.9087 12.2826 20.9087 12.7355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatarEsophia);
export default __webpack_public_path__ + "static/media/icon_avatar_esophia.6ccf68786e0690eca501352d346e7b90.svg";
export { ForwardRef as ReactComponent };